<!--
 * @Descripttion: 
 * @version: 单行省市区根据某字段模糊查询组件
 * @Author: dengyao
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-11-28 15:46:25
-->
<template>
  <Select v-if="issingleChoice" v-model:value="value" show-search :placeholder="$lang('请输入')" style="display: flex"
    :default-active-first-option="false" :show-arrow="true" :filter-option="false" :not-found-content="null"
    :options="data" @search="handleSearch" @change="handleChange"></Select>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue'
import { Select } from 'ant-design-vue'
import { debounce } from 'lodash-es'
import { useApi } from '@tmp/site-common'
type Props = {
  value: string | Array<any>
  /**接口url */
  ajaxUrl: any
  /**入参的名字 */
  params: string
  /**是否单选  */
  issingleChoice: boolean
}
const props = withDefaults(defineProps<Props>(), {
  params: 'name',
  issingleChoice: true
})
const box_list = useApi(props.ajaxUrl)
/**单选 */
const data = ref<any[]>([])
const value = ref(props.value)
const emit = defineEmits(['update:value', 'exportObj'])
const handleSearch = debounce((val: string) => {
  if (!val.trim()) return
  box_list.fetchData({ [props['params']]: val }).then((res) => {
    data.value = res.data.records.map((item: any) => {
      return {
        area: item.area,
        areaCode: item.areaCode,
        city: item.city,
        cityCode: item.cityCode,
        province: item.province,
        provinceCode: item.provinceCode,
        town: item.town,
        townCode: item.townCode,
        label: `${item.town} ${item.area} ${item.city} ${item.province}`,
        value: item.townCode
      }
    })
  })
}, 300)

/**多选 */
watch(
  () => props.value,
  (c) => {
    value.value = c
  }
)
/**导出一个exportObj，包含选中当前行的所有数据 */
const handleChange = (val?: any) => {
  value.value = val
  const item = data.value.find((_: any) => _.townCode === val)
  emit('update:value', val)
  emit('exportObj', item)
}
defineExpose({ handleSearch })
</script>
<style lang="less" scoped></style>
